import { axiosInstance } from "../../../axios/axiosInstance";

const API_PREFERRED_LANGUAGE = "auth/update-preferred-language";

export const languageService = (dataToBeSent) => {
  return axiosInstance.patch(API_PREFERRED_LANGUAGE, dataToBeSent);
};
